import React, { useEffect, useState } from "react";
import Container from "../../components/Layout/Container";
import ContentBlock from "../../components/Layout/ContentBlock";
import FilterMenu from "../../components/Layout/FilterMenu";
import { ButtonDelete, ButtonEditRow } from "../../components/common/Buttons";
import TableFilterBox from "../../components/common/TableFilterBox";
import ContentValidation from "../../components/common/ContentValidation";
import {
  SelectInput,
  TextInput,
  ButtonSecondary,
} from "../../components/globals";
import TableUi from "../../components/Layout/TableUI";
import { Button, Form, Input, Select } from "antd";
import { handleKeyDown2 } from "../../helpers/FunctionsGlobal";
import { IconBooksStacked } from "../../components/Layout/Icons";
import { useModal, useFetch } from "../../hooks";
import ModalSimple from "../../components/Layout/Modals/ModalSimple";
import { getCarriersActive } from "../../redux/Actions/carrier_action";
import { QueryClient, QueryClientProvider, useMutation } from "react-query";
import Axios from "axios";
import { antdMessageError, antdMessageSuccess } from "../../helpers/Utils";

const queryClient = new QueryClient();

function DeliveriesManagementPage({ match }) {
  return (
    <QueryClientProvider client={queryClient}>
      <DeliveriesManagementComponent match={match} />
    </QueryClientProvider>
  );
}
export default DeliveriesManagementPage;

function DeliveriesManagementComponent({ match }) {
  const [carriers, setCarriers] = useState([]);
  const { modalOpt, setModalOpt, closeModal } = useModal();
  const [groupData, setGroupData] = useState([]);
  const [selectedCarrier, setSelectedCarrier] = useState("");
  const [groupNameFilter, setGroupNameFilter] = useState("");
  const {
    value,
    loading: loadingData,
    setReFetch,
  } = useFetch(`/api/v1/carrier_groups`);

  const mutationDelete = useMutation({
    mutationFn: (id) =>
      Axios({
        url: `/api/v1/carrier_groups/${id}`,
        method: "DELETE",
      }).then((res) => res.data),
    onSuccess: () => {
      antdMessageSuccess();
      setReFetch();
    },
    onError: (error) => {
      antdMessageError(error?.response?.data?.message);
    },
  });
  const clearFilter = () => {
    setGroupNameFilter("");
    setGroupData(value.data);
  };

  const onFilter = () => {
    let filteredData = value.data;

    if (groupNameFilter) {
      filteredData = filterByTitle(filteredData, groupNameFilter);
    }

    if (selectedCarrier) {
      console.log(selectedCarrier, "selectedCarrier");
      filteredData = filterByCarrier(filteredData, selectedCarrier);
    }

    setGroupData(filteredData);
  };

  function filterByTitle(data, title) {
    return data.filter((item) =>
      item.title.toLowerCase().includes(title.toLowerCase())
    );
  }

  function filterByCarrier(data, carriers) {
    return data.filter((item) =>
      item.carriers.some((c) => carriers.includes(c.name))
    );
  }

  useEffect(() => {
    setReFetch();
  }, [modalOpt]);

  useEffect(() => {
    getCarriersActive().then((carriers) => setCarriers(carriers));
  }, []);

  useEffect(() => {
    if (value !== undefined) {
      setGroupData(value.data);
    }
  }, [value]);

  return (
    <QueryClientProvider client={queryClient}>
      <Container
        location={{
          locationName: "Types management",
          locationUrl: match.url,
        }}
      >
        <ContentBlock>
          <FilterMenu
            length={groupData.length || 0}
            iconComponent={<IconBooksStacked />}
            text2="groups"
          />
        </ContentBlock>

        <ContentBlock>
          <TableFilterBox
            filter={true}
            onFilter={() => onFilter()}
            clearFilter={() => clearFilter()}
            button1={
              <>
                <div
                  className="float-left ml-2"
                  style={{
                    width: 104,
                  }}
                >
                  <ButtonSecondary onClick={() => setModalOpt("new_group", 1)}>
                    New group
                  </ButtonSecondary>
                </div>
              </>
            }
          >
            <div className="px-1 d-flex">
              <div>
                <TextInput
                  text="Group name"
                  style={{ width: 165 }}
                  name={groupNameFilter}
                  value={groupNameFilter || ""}
                  onKeyDown={handleKeyDown2(onFilter)}
                  onChange={(val) => {
                    const value = val.target.value;
                    setGroupNameFilter(value);
                  }}
                />
              </div>
              <div className="ml-2 w-200">
                <SelectInput
                  mode={"multiple"}
                  label="Delivery type"
                  style={{ width: 165 }}
                  options={carriers.map((carrier) => ({
                    value: carrier.value,
                    label: carrier.label,
                  }))}
                  value={
                    selectedCarrier.length > 0 ? selectedCarrier : undefined
                  }
                  onChange={(value) => {
                    setSelectedCarrier(value);
                  }}
                />
              </div>
            </div>
          </TableFilterBox>
          <div>
            <ContentValidation loader={loadingData} array={groupData}>
              <div className="table-responsive">
                <TableUi
                  ths={["Group name", "Delivery type", ""]}
                  total={groupData?.length || 0}
                >
                  {groupData?.map((data, index) => (
                    <TableUi.tr key={index}>
                      <TableUi.td>
                        <div style={{ paddingLeft: 15 }}>
                          <p className="group-title">{data?.title}</p>
                        </div>
                      </TableUi.td>
                      <TableUi.td>
                        <div
                          className="d-flex flex-row flex-wrap gap-1"
                          style={{ paddingTop: 15, marginBottom: 15 }}
                        >
                          {data?.carriers?.map((item, i) => (
                            <div
                              className="borderder-component-text-grey d-flex flex-row"
                              key={i}
                            >
                              <p className="mr-1">{`[${item?.order_shop}] `}</p>
                              <p>{item?.name}</p>
                            </div>
                          ))}
                        </div>
                      </TableUi.td>
                      <TableUi.td>
                        <div
                          className="d-flex flex-row gap-1 justify-content-end"
                          style={{ marginRight: 15 }}
                        >
                          <ButtonEditRow
                            onClick={() => setModalOpt("edit", index)}
                          />
                          <ButtonDelete
                            onDelete={() => mutationDelete.mutate(data.id)}
                          />
                        </div>
                      </TableUi.td>
                    </TableUi.tr>
                  ))}
                </TableUi>
                {/* <PaginationComp
                                    page={parseInt(filters?.page) || 1}
                                    setPagination={(value) => {
                                        setFilters((prev) => ({
                                            ...prev,
                                            page: value + "",
                                        }));
                                    }}
                                    totals={totals}
                                    pageCount={pageCount}
                                /> */}
              </div>
            </ContentValidation>
          </div>
        </ContentBlock>
        {modalOpt?.type && (
          <ModalNewGroup
            modalOpt={modalOpt}
            onClose={closeModal}
            groupData={groupData}
            parentCarriers={carriers}
          />
        )}
      </Container>
    </QueryClientProvider>
  );
}

const ModalNewGroup = ({ modalOpt, onClose, groupData, parentCarriers }) => {
  const [carriers, setCarriers] = useState([]);
  const [fetchedCarriers, setFetchedCarriers] = useState([]);

  useEffect(() => {
    const carriers = parentCarriers;
    const usedCarriers = Object.values(groupData).flatMap(
      (group) => group.carriers?.map((carrier) => carrier.id) || []
    );
    const filteredCarriers = carriers.filter(
      (carrier) => !usedCarriers.includes(carrier.id)
    );
    console.log(parentCarriers, "parentCarriers");
    console.log(groupData, "groupData");
    console.log(filteredCarriers, "filteredCarriers");
    setFetchedCarriers(carriers);
    setCarriers(filteredCarriers);
  }, [groupData]);

  useEffect(() => {
    if (modalOpt.type === "edit" && groupData[modalOpt.record_id]) {
      const selectedCarriers =
        groupData[modalOpt.record_id].carriers?.map((carrier) => ({
          key: carrier.id,
          label: parentCarriers.find((pCarrier) => pCarrier.id === carrier.id)
            .label,
        })) || [];
      setCarriers((prevCarriers) => [
        ...prevCarriers,
        ...fetchedCarriers.filter((carrier) =>
          selectedCarriers.some(
            (selectedCarrier) => selectedCarrier.key === carrier.id
          )
        ),
      ]);
      form.setFieldsValue({
        title: groupData[modalOpt.record_id].title,
        pickup_address_ids: selectedCarriers,
      });
    }
  }, [modalOpt.type, groupData]);

  const [form] = Form.useForm();

  const mutationPost = useMutation({
    mutationFn: (newData) =>
      Axios({
        url: `/api/v1/carrier_groups`,
        method: "POST",
        data: { carrier_group: newData },
      }).then((res) => res.data),
    onSuccess: () => {
      antdMessageSuccess();
      onClose();
    },
    onError: (error) => {
      antdMessageError(error?.response?.data?.message);
    },
  });

  const mutationPut = useMutation({
    mutationFn: (updatedData) =>
      Axios({
        url: `/api/v1/carrier_groups/${groupData?.[modalOpt.record_id]?.id}`,
        method: "PUT",
        data: { carrier_group: updatedData },
      }).then((res) => res.data),
    onSuccess: () => {
      antdMessageSuccess();
      onClose();
    },
    onError: (error) => {
      antdMessageError(error?.response?.data?.message);
    },
  });

  return (
    <ModalSimple
      text={modalOpt.type === "edit" ? "Edit group" : "Create new group"}
      onClose={onClose}
      hide={true}
    >
      <Form
        form={form}
        layout="vertical"
        name="basic"
        onFinish={(values) => {
          const newCarrierIds = values.pickup_address_ids.map(
            (carrier) => carrier.key
          );

          const transformedValues = {
            title: values.title,
            carrier_ids: newCarrierIds,
          };

          if (modalOpt.type === "edit") {
            mutationPut.mutate(transformedValues);
          } else {
            mutationPost.mutate(transformedValues);
          }
        }}
        autoComplete="off"
      >
        <Form.Item
          label="Group name"
          name="title"
          rules={[
            {
              required: true,
              message: "Please input your group name!",
            },
          ]}
        >
          <Input placeholder="Type in" />
        </Form.Item>

        <Form.Item
          label="Delivery type"
          name="pickup_address_ids"
          rules={[
            {
              required: true,
              message: "Please select!",
            },
          ]}
        >
          <Select
            mode="multiple"
            placeholder="Select"
            labelInValue
            value={carriers.map((carrier) => ({
              key: carrier.id,
              label: carrier.label,
            }))}
            onChange={(newValues) => {
              if (modalOpt.type === "edit" && groupData[modalOpt.record_id]) {
                const previousCarrierIds =
                  groupData[modalOpt.record_id].carriers?.map(
                    (carrier) => carrier.id
                  ) || [];
                const removedCarrierIds = previousCarrierIds.filter(
                  (id) => !newValues.map((value) => value.key).includes(id)
                );
                const updatedCarriers = fetchedCarriers.filter(
                  (carrier) => !removedCarrierIds.includes(carrier.id)
                );
                setCarriers(updatedCarriers);
              }
            }}
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
          >
            {carriers.map(({ label, id }) => (
              <Select.Option key={id} value={id}>
                {label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item>
          <Button className="w-100" type="primary" htmlType="submit">
            Update
          </Button>
        </Form.Item>
      </Form>
    </ModalSimple>
  );
};
